<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="480px"
    custom-class="ca-cancel-dialog"
    :close-on-click-modal="true"
  >
    <div slot="title" class="ca-cancel-dialog__title">
      <i class="el-icon-warning ca-cancel-dialog__icon" />
      <span>提示</span>
    </div>
    <div class="ca-cancel-dialog__order">
      <span class="ca-cancel-dialog__order-label">订单号：</span>{{ order.orderCode }}
    </div>

    <!-- 警示文案（含取消时限等业务说明） -->
    <div class="ca-cancel-dialog__warn">
      订单取消后将无法再次提交，是否继续操作？
    </div>
    <div slot="footer">
      <el-button class="ca-cancel-dialog__cancel" @click="innerVisible = false">取消</el-button>
      <el-button type="danger" :loading="loading" @click="$emit('confirm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CaCancelOrderDialog',
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
  },
}
</script>
